module.exports = __webpack_public_path__ + "static/media/richmondHappyHour.12e3b5d8.pdf";